"use client"

import { useState } from "react"

export const useEdit = () => {
  const [editingId, setEditingId] = useState<string | null>(null)
  const [editingName, setEditingName] = useState("")

  const startEdit = (id: string, currentName: string) => {
    setEditingId(id)
    setEditingName(currentName)
  }

  const cancelEdit = () => {
    setEditingId(null)
    setEditingName("")
  }

  return {
    editingId,
    editingName,
    setEditingName,
    startEdit,
    cancelEdit,
  }
}


